import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import Seo from "../seo/Seo";
import logo from "../assets/img/logo.svg";
import craneGif from "../assets/pixel/crane.gif";
import "../scss/simple-pages.scss";

export default function NotFound() {
  const { t, lp } = useI18n();
  return (
    <main className="simple-page">
      <Seo title={t("seo.notFound.title")} description={t("seo.notFound.description")} noindex />
      <div className="simple-card">
        <Link to={lp("/")} className="simple-logo" aria-label={t("common.home")}>
          <img src={logo} alt="Tehnočin DOO Invest" width="130" height="85" />
        </Link>
        <img src={craneGif} alt="" className="pixel simple-art" width="48" height="48" />
        <p className="simple-code">404</p>
        <h1>{t("notFound.title")}</h1>
        <p>{t("notFound.text")}</p>
        <div className="simple-actions">
          <Link to={lp("/katalog")} className="btn btn--lg btn--block">
            {t("common.seeUnits")}
          </Link>
          <Link to={lp("/")} className="btn btn--ghost btn--lg btn--block">
            {t("notFound.home")}
          </Link>
        </div>
      </div>
    </main>
  );
}
